export default {
  dadosSessao: null,
  valorDefaultAutoComplete: {
    key: null,
    value: 'Nenhum resultado encontrado'
  },
  documentoCadastro: {
    cidadeChave: '',
    estadoChave: '',
    paisChave: '001000000000000000000000',
    pais: 'Brasil'
  },
  isVisible: {},
  filtroInteressados: {
    idDepartamento: '',
    nome: null,
    cpf: null,
    cnpj: null,
    matricula: null,
    tipoInteressado: ''
  },
  filtroPesquisaAReceber: {
    numeroProcesso: '',
    numeroGuia: '',
    usuarioEnvio: '',
    cidadeRemetente: '',
    assunto: '',
    interessados: '',
    offset: 1,
    range: 10,
    armazenado: false,
    arquivado: false,
    anexado: false,
    eliminado: false,
    apensado: false,
    emTramite: true
  },
  progressFiltroGeral: {
    change: true
  },
  filtroGeral: {},
  auxFiltroGeral: {},
  processosTramitacao: [],
  processosGuia: [],
  filtroDestinatario: {},
  motivosProcessos: {},
  contatoSelecionado: null,
  motivoSelecionado: null,
  apensarProcessoSelecionado: {},
  anexarProcessoSelecionado: {},
  interessadosSelecionados: [],
  processoCadastro: {
    id: '',
    tipoProcesso: '',
    sigiloso: '',
    complementoSetor: '',
    usuarioCriacao: '',
    nomeUsuario: '',
    idOrgao: '',
    siglaOrgao: '',
    idDepartamento: '',
    siglaDepartamento: '',
    codigoHierarquia: '',
    estado: '',
    cidade: '',
    numeroProcesso: {},
    assunto: {},
    especie: {},
    numeroAnexos: 0
  },
  dataTableChecked: [],
  keyTableChecked: [],
  loading: {
    count: 0,
    is: false
  },
  notification: {
    alert: {
      type: '',
      texto: ''
    },
    key: true,
    component: '',
    params: {}
  },
  withoutReload: [
    '/status',
    '/recurso/build'
  ]
}
